import React from 'react';

const EllipseIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="178"
        height="178"
        viewBox="0 0 178 178"
        fill="none"
    >
        <g filter="url(#filter0_d_522_2882)">
            <circle
                cx="89"
                cy="86"
                r="74"
                fill="#C5DEFF"
                fillOpacity="0.4"
                shapeRendering="crispEdges"
            />
        </g>
        <defs>
            <filter
                id="filter0_d_522_2882"
                x="0"
                y="0"
                width="178"
                height="178"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="3" />
                <feGaussianBlur stdDeviation="7.5" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.92549 0 0 0 0 0.952941 0 0 0 0 0.996078 0 0 0 0.4 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_522_2882"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_522_2882"
                    result="shape"
                />
            </filter>
        </defs>
    </svg>
);

export default EllipseIcon;
